export default __webpack_public_path__ + "static/media/Arrow 2 Down.ea82fc7c.svg";